// extracted by mini-css-extract-plugin
module.exports = {"preview-loader":"y_b8","previewLoader":"y_b8"};